require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/events.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/events.legacy.js
// module id = 624
// module chunks = 31